<template>

    <v-event :date="charge.created_at" :actions="[{ key: 'delete', value: 'Delete Charge' }]" @action="onActionSelected">
        <template #title>
            <i v-if="charge.amount >= 0" class="fas fa-arrow-up text-success mr-10"></i>
            <i v-else class="fas fa-reply text-danger mr-10"></i>
            <span class="title">{{ charge.amount / 100 | currencyForProject }}</span>
        </template>
        <template #body>
            <table>
                <tr>
                    <td class="key">date</td>
                    <td class="value">{{ charge.created_at | dateTime }}</td>
                </tr>
            </table>
        </template>
    </v-event>

</template>

<script>

import CustomerApi from '@api/CustomerApi';
import Event from './Event';

export default {

    components: {
        'v-event': Event,
    },

    props: {
        charge: {
            type: Object,
            required: true,
        },
    },

    methods: {

        onActionSelected(item) {
            if (item.key === 'delete') {
                CustomerApi.deleteCharge(this.charge.customer_id, this.charge.id)
                    .then((response) => {
                        this.$store.commit('setAlertSuccess', this.$t('message.deleted'));
                        this.$emit('deleted');
                    }, (error) => {
                        this.$store.commit('setAlertWithError', error);
                    });
            }
        },

    },

}

</script>
